import { format } from "date-fns";

export default function StringToDateTime(date_str) {
    if (date_str !== undefined) {
        return format(new Date(date_str), 'dd.MM.yyyy HH:mm')
    }
    else {
        return null
    }
}